import { pluck, componentFactory, datasetFactory } from '../../../fc-core/src/lib';
import { removeComponents } from './dataset.helper';
var MULTISERIESCOLUMNMANAGER = 'multiseriesColumnManager';
export default function (a) {
  var b,
      c,
      d,
      e,
      f,
      g,
      h,
      j,
      k,
      l = a.getFromEnv('dataSource'),
      m = l.dataset,
      n = a.getChildren(),
      o = n.canvas[0],
      p = o.getChildren('vCanvas'),
      q = p[0],
      r = p[1],
      s = a.getFromEnv('chartConfig').isdual,
      t = {
    vCanvasDatasetsDef0: {},
    vCanvasDatasetsDef1: {}
  },
      u = {
    vCanvas0: {},
    vCanvas1: {}
  };

  for (m || a.setChartMessage(), c = 0; c < m.length; c++) {
    b = m[c], h = b.parentyaxis || '', 's' === h.toLowerCase() && s ? (g = pluck(b.renderas, a.config.sDefaultDatasetType), j = r, k = u.vCanvas1, d = t.vCanvasDatasetsDef1) : (g = pluck(b.renderas, a.config.defaultDatasetType), j = q, k = u.vCanvas0, d = t.vCanvasDatasetsDef0), g = a.getDSType(g, 's' === h.toLowerCase()), f = a.getDSGroupdef(g, 's' === h.toLowerCase()), f && (componentFactory(j, f, MULTISERIESCOLUMNMANAGER), k[f.getName().toLowerCase()] = !0), k[g.toLowerCase()] = !0, d[g] ? (d[g].conf.push(b), d[g].indices.push(c)) : (d[g] = {}, d[g].indices = [c], d[g].classDef = a.getDSdef(g), d[g].conf = [b], d[g].pYAxis = h.toLowerCase(), d[g].parent = f ? j.getChildren(MULTISERIESCOLUMNMANAGER)[0] : j);
  }

  for (var _b in a.config._hascolumn = !1, t) {
    if (t.hasOwnProperty(_b)) for (g in d = t[_b], d) {
      d.hasOwnProperty(g) && (e = d[g], 'group' === e.parent.getType() && e.parent.configure(e.conf), datasetFactory(e.parent, e.classDef, 'dataset_' + g, e.conf.length, e.conf, e.indices), 'column' === g && (a.config._hascolumn = !0));
    }
  }

  removeComponents(p[0], Object.keys(u.vCanvas0)), removeComponents(p[1], Object.keys(u.vCanvas1));
}